export * from "app/model";
export * from "./pm.model";
export * from "./wrsv.model";
export * from "./apr.model";
export * from "./cm.model";


export interface PlanDateRequest {
    id?: string;
    planDate: string;
    remark: string;
    wellStringId?: string;
}

export enum WIPType {
    pm =  'Preventive Maintenance',
    wrsv =  'WRSV',
    apr =  'Annulus Pressure Record',
    cm =  'Corrective Maintenance',
    adhoc = 'Ad-hoc Activity',
    other = 'Other Activity'
}

export type PlanDateAction = 'create' | 'edit';